import type {ToolPartState} from "@project/design-system-web";

import {ToolCallStatus} from "@copilotkit/react-core/v2";

interface ToolPartStateOptions {
  hasError?: boolean;
  isApprovalPending?: boolean;
  severity?: "success" | "warning" | "danger";
  status?: ToolCallStatus;
}

export function normalizeToolCallStatus(status: unknown): ToolCallStatus {
  if (status === ToolCallStatus.Complete) return ToolCallStatus.Complete;
  if (status === ToolCallStatus.Executing) return ToolCallStatus.Executing;
  if (status === ToolCallStatus.InProgress) return ToolCallStatus.InProgress;

  if (status === "complete" || status === "result") return ToolCallStatus.Complete;
  if (status === "executing" || status === "call") return ToolCallStatus.Executing;

  return ToolCallStatus.InProgress;
}

export function toToolPartState({
  hasError,
  isApprovalPending,
  severity,
  status,
}: ToolPartStateOptions): ToolPartState {
  if (isApprovalPending) return "requires-action";
  if (hasError || severity === "danger") return "output-error";

  if (status === ToolCallStatus.Complete) return "output-available";
  if (status === ToolCallStatus.Executing) return "input-available";

  return "input-streaming";
}
